/**
 * Microsoft Authentication Library (MSAL) Configuration
 * 
 * To use this configuration:
 * 1. Register your application in Azure Portal (portal.azure.com)
 * 2. Go to Azure Active Directory > App registrations > New registration
 * 3. Set redirect URI to: http://localhost:3000 and https://your-domain.com
 * 4. Copy the Application (client) ID and paste it below
 * 5. Copy the Directory (tenant) ID and paste it below
 * 6. Under "Authentication", enable "Access tokens" and "ID tokens"
 */

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "YOUR_CLIENT_ID_HERE", // Replace with your Azure AD app client ID
    authority: process.env.REACT_APP_AZURE_AUTHORITY || "https://login.microsoftonline.com/YOUR_TENANT_ID_HERE", // Replace YOUR_TENANT_ID_HERE
    redirectUri: window.location.origin, // Always use current origin to support all subdomains
    postLogoutRedirectUri: window.location.origin
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case "Error":
            console.error(message);
            return;
          case "Info":
            console.info(message);
            return;
          case "Verbose":
            console.debug(message);
            return;
          case "Warning":
            console.warn(message);
            return;
          default:
            return;
        }
      }
    }
  }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints
export const loginRequest = {
  scopes: ["User.Read", "email", "profile", "openid"]
};

// Add the endpoints here for Microsoft Graph API services you'd like to use
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
